// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "合同法",
      "tec": "曲明",
      "week": "1-16周",
      "add": "教学楼D座222经管"
    },
    {
      "sub": "商法",
      "tec": "牛玉璞",
      "week": "1-16周",
      "add": "教学楼D座222经管"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "韩巍岩",
      "week": "1-12周",
      "add": "教学楼A座422机械"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "行政法与行政诉讼法",
      "tec": "杨继慧",
      "week": "1-14周",
      "add": "教学楼D座213经管"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25经管法1-3",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25经管法1-2",
        "tec": "宋大明",
        "week": "1-14周",
        "add": "教学楼D座320经管"
      },
      {
        "sub": "25经管法2-2",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "教学楼D座315文法"
      },
      {
        "sub": "25经管法1-4",
        "tec": "吕双双",
        "week": "1-14周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "25经管法2-1",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "教学楼D座221经管"
      },
      {
        "sub": "25经管法1-1",
        "tec": "贺静",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25经管法1-5",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "教学楼B座319能动"
      },
      {
        "sub": "25经管法1-7",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "实训楼E座310"
      }
    ],
    {
      "sub": "商法",
      "tec": "牛玉璞",
      "week": "7-8周",
      "add": "教学楼D座222经管"
    },
    {
      "sub": "科技文献检索",
      "tec": "李宏宇",
      "week": "1-4周",
      "add": "教学楼A座221电力"
    },
    0
  ],
  "3": [
    {
      "sub": "商法",
      "tec": "牛玉璞",
      "week": "1-16周",
      "add": "教学楼D座227经管"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "李庆",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "轮滑",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男网",
        "tec": "李罡",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "足球",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "搏击",
        "tec": "李莉",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "女篮",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "女排",
        "tec": "高佳",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男乒",
        "tec": "李灏",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男乒",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "男羽",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "女网",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "健美操"
      },
      {
        "sub": "足球",
        "tec": "张慧",
        "week": "1-18周",
        "add": "健美操"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "中国近现代史纲要",
      "tec": "韩巍岩",
      "week": "1-12周",
      "add": "教学楼A座422机械"
    },
    {
      "sub": "合同法",
      "tec": "曲明",
      "week": "1-16周",
      "add": "教学楼D座222经管"
    },
    [
      {
        "sub": "商法",
        "tec": "牛玉璞",
        "week": "1-6周",
        "add": "教学楼D座222经管"
      },
      {
        "sub": "就业创业指导",
        "tec": "王星月",
        "week": "11-12,14-16周",
        "add": "教学楼D座315文法"
      }
    ],
    0,
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "1-4周",
      "add": "教学楼C座306教务"
    }
  ],
  "5": [
    {
      "sub": "行政法与行政诉讼法",
      "tec": "杨继慧",
      "week": "1-14周",
      "add": "教学楼D座223经管"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "傅瑶",
      "week": "1-16周",
      "add": "教学楼C座304教务"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "25经管法1-6",
        "tec": "马丹",
        "week": "1-14周",
        "add": "教学楼D座221经管"
      },
      {
        "sub": "25经管法1-2",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "教学楼D座213经管"
      },
      {
        "sub": "25经管法1-3",
        "tec": "贺静",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "25经管法1-5",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25经管法1-1",
        "tec": "吕双双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25经管法2-1",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25经管法1-4",
        "tec": "宋大明",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25经管法2-2",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "实训楼E座412语音室"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
